import Header from './Header';
import Footer from './Footer';

export default function Layout({ children }) {
  return (
    <div className="grain relative min-h-screen bg-[#F5EFE1]">
      <Header />
      <main className="pt-20 md:pt-24">{children}</main>
      <Footer />
    </div>
  );
}
